import { RecordingIndicatorColoredIcon } from '@carboncopyco/icons';
import type { IRecording } from '@carboncopyco/types';
import { RecordingTypes } from '@carboncopyco/types';
import { TooltipBubble } from '@carboncopyco/ui';
import { useCallback } from 'react';
import { SearchResultTile } from '../../../GridTiles';
import { useWorkspacePageProps } from '../WorkspacePageContext';

import { CloneActionsDropdown } from './EntitiesActionsDropdown/CloneActionsDropdown';

export const CloneSearchResultTile = ({
  archived,
  clone,
  inFolder,
}: {
  clone: IRecording;
  archived?: boolean;
  inFolder?: boolean;
}) => {
  const { goToClone } = useWorkspacePageProps();

  const DropdownAction = useCallback(
    ({ isMenuOpen, toggleMenu }) => {
      return (
        <CloneActionsDropdown
          clone={clone}
          handleMenuOpen={toggleMenu}
          archived={archived}
          inFolder={inFolder}
        />
      );
    },
    [clone, archived, inFolder]
  );

  return (
    <SearchResultTile
      lastUpdated={clone.updateTime}
      title={clone.recordName}
      image={clone.image}
      isDesktop={clone.recordingType === RecordingTypes.native}
      onTileClick={archived ? undefined : () => goToClone(clone.id)}
      ActionDropdown={DropdownAction}
      icon={
        <TooltipBubble
          placement="top"
          title="Clone"
        >
          <RecordingIndicatorColoredIcon size={18} />
        </TooltipBubble>
      }
      // TODO change this after processing clone is ready
      // isPending={
      //   clone?.postprocessState &&
      //   clone.postprocessState === RecordingPostprocessStateTypes.pending
      // }
      isPending={false}
    />
  );
};
